import {
  FAQS,
  REGISTRATION_CARDS,
  TERMS_AND_CONDITION,
  REGISTER_TERMS_AND_CONDITIONS,
} from "./helper";
import { routes } from "src/shared/routes";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const fcs_pass: TTeamConfig = {
  TEAM_SCHEMA: "fcs_pass",
  TEAM_FULL_NAME: "FCS Cheez-It Bowl Pass",
  BROWSER_TITLE: "FCS Cheez-It Bowl Pass",
  CLIENT_ID: "72e889905a8c.seasonshare.fcs-citrusbowl.us",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#EE7623",
    COLORS_SECONDARY: "#EE7623",
    DEFAULT_APP_ROUTE: routes.landing,
    ACCOUNT_MANAGER_URL: "https://am.ticketmaster.com/fcs/",
    LOGOUT_ON_INVALID_SESSION: true,
    IS_INTERCOM_ENABLED: true,

    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
    },
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
      HIDE_PASS_DETAILS: true,
    },

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
    },

    HIDE_PASSES: true,
    HIDE_UPCOMING_EVENTS: true,
    SHOW_ALL_PASSES_UNDER_BANNER: false,

    REGISTRATION_CARD_SETTINGS: {
      REGISTRATION_CARDS,
    },

    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },
  },

  AUTH_PAGE_SETTINGS: {
    PHONE_INPUT_WIDGET: {
      TERMS_AND_CONDITION: <REGISTER_TERMS_AND_CONDITIONS />,
    },
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },

    HIDE_PASSES: true,
    HIDE_UPCOMING_EVENTS: true,

    REGISTRATION_CARD_SETTINGS: {
      REGISTRATION_CARDS: REGISTRATION_CARDS,
    },

    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: true,
    },

    ADD_ONS_LABEL: "Tickets",
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL: "https://ss-leagues.s3.amazonaws.com/FC%20Sports/FCS%20Logo.png",
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/FC%20Sports/1600x550-Stadium-Background-Image.jpg",
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/FC%20Sports/25_Cheez-It_Citrus_Bowl_Postgame_Concert_Attend_375x550.png",
    GROUP_INVITE_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/FC%20Sports/25_Cheez-It_Citrus_Bowl_Postgame_Concert_Attend_1920x450.png",
    LANDING_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/FC%20Sports/25_Cheez-It_Citrus_Bowl_Postgame_Concert_Attend_1920x450.png",
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
  },
};
